module.exports = __webpack_public_path__ + "img/cnn.3c10fbc5.jpg";